import { http } from '../../../utils';
const controller = 'service-desk/issue-solutions';
export const getIssueSolutions = async (page, pageSize, orderBy, searchCondition, objectTypeId, sequenceIssueCauseId, isPriority, status) => {
    return await http.get(controller, {
        params: {
            searchCondition,
            sequenceIssueCauseId,
            isPriority,
            status,
            objectTypeId,
            page,
            pageSize,
            orderBy
        }
    });
};
export const getIssueSolution = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addIssueSolution = async (IssueSolution) => {
    return http.post(controller, IssueSolution);
};
export const updateIssueSolution = async (id, IssueSolution) => {
    return await http.put(`${controller}/${id}`, IssueSolution);
};
export const deleteIssueSolution = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getIssueSolutionsDropdown = async () => {
    return await http.get(`${controller}/dropdown`);
};
export const addListIssueSolution = async (solutions) => {
    return http.post(`${controller}/add-list`, solutions);
};
